<app-header login= 'yes'></app-header>

<div class="responsive">
    <div class="container-fluid">



        <div class="row">
            <div class="col-md-2">
                </div>



            <div class="col-md-8">
                <app-shared-profile [props]="communityData" type="" [loading]="loading"></app-shared-profile>
            </div>


            <div class="col-md-2">
            </div>

        </div>
    </div>
</div>